"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRingGroupSchema = exports.updateRingGroupSchema = exports.createRingGroupSchema = exports.ringGroupSchema = exports.listAAOptionsSchema = exports.deleteAAOptionSchema = exports.updateAAOptionSchema = exports.createAAOptionSchema = exports.listAutoAttendantsSchema = exports.deleteAutoAttendantSchema = exports.updateAutoAttendantSchema = exports.createAutoAttendantSchema = exports.autoAttendantSchema = exports.autoAttendantOptionSchema = exports.listMailboxesSchema = exports.deleteMailboxSchema = exports.updateMailboxSchema = exports.createMailboxSchema = exports.mailboxSchema = exports.listPhoneNumbersSchema = exports.deletePhoneNumberSchema = exports.updatePhoneNumberSchema = exports.createPhoneNumberSchema = exports.phoneNumberSchema = exports.listExtensionsSchema = exports.deleteExtensionSchema = exports.updateExtensionSchema = exports.createExtensionSchema = exports.extensionSchema = exports.applyPlanSchema = exports.generatePlanSchema = exports.listCollaboratorsSchema = exports.resendInvitationSchema = exports.updateCollaboratorRoleSchema = exports.removeCollaboratorSchema = exports.inviteCollaboratorSchema = exports.addCollaboratorSchema = exports.collaboratorRoleSchema = exports.deleteProjectSchema = exports.approveProjectSchema = exports.requestChangesSchema = exports.submitForReviewSchema = exports.updateProjectSchema = exports.updateSmsComplianceSchema = exports.updateCompanyInfoSchema = exports.createProjectSchema = exports.createProjectOrgSchema = exports.contactAccessSchema = exports.projectListItemSchema = exports.projectStatusSchema = void 0;
exports.deleteTaskSchema = exports.updateTaskSchema = exports.createTaskSchema = exports.taskSchema = exports.listCommentsSchema = exports.deleteCommentSchema = exports.updateCommentSchema = exports.createCommentSchema = exports.commentSchema = exports.exportPhoneNumbersSchema = exports.importPhoneNumbersCommitSchema = exports.importPhoneNumbersPreviewSchema = exports.exportExtensionsSchema = exports.importExtensionsCommitSchema = exports.importExtensionsPreviewSchema = exports.listTodRoutersSchema = exports.deleteTodRouterSchema = exports.updateTodRouterSchema = exports.createTodRouterSchema = exports.todRouterSchema = exports.todRouterBindingSchema = exports.listHolidaysSchema = exports.deleteHolidaySchema = exports.updateHolidaySchema = exports.createHolidaySchema = exports.holidaySchema = exports.listTimeframesSchema = exports.deleteTimeframeSchema = exports.updateTimeframeSchema = exports.createTimeframeSchema = exports.timeframeSchema = exports.timeframeRuleSchema = exports.listSitesSchema = exports.deleteSiteSchema = exports.updateSiteSchema = exports.createSiteSchema = exports.siteSchema = exports.listConferenceBridgesSchema = exports.deleteConferenceBridgeSchema = exports.updateConferenceBridgeSchema = exports.createConferenceBridgeSchema = exports.conferenceBridgeSchema = exports.setQueueMembersSchema = exports.listQueuesSchema = exports.deleteQueueSchema = exports.updateQueueSchema = exports.createQueueSchema = exports.queueSchema = exports.setRingGroupMembersSchema = exports.listRingGroupsSchema = void 0;
exports.getInfrastructureSchema = exports.infrastructureSchema = exports.listTasksSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const pin_1 = require("./pin");
// Project Status
exports.projectStatusSchema = zod_1.z.enum(["draft", "in_review", "approved", "provisioned"]);
// Project List Item (lightweight for list views)
exports.projectListItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    status: exports.projectStatusSchema,
    currentStep: zod_1.z.string(),
    projectType: zod_1.z.enum(["new_customer", "new_location", "mac_order"]).optional(),
    createdAt: zod_1.z.date().or(zod_1.z.string().transform(str => new Date(str))),
    updatedAt: zod_1.z.date().or(zod_1.z.string().transform(str => new Date(str))),
    // Project configuration summary (from initial setup)
    seats: zod_1.z.number().int().nullable().optional(),
    didsCount: zod_1.z.number().int().nullable().optional(),
    callCenterAgents: zod_1.z.number().int().nullable().optional(),
});
// Create Project (SALES/ADMIN, SP1 §4.4). Staff pick the owning org explicitly: an
// existing customer org, or a new one whose main contact is invited as its org admin.
// Each additional contact gets an org invite ("organization") or a project invite
// ("project"). Nothing is derived from email domains.
exports.contactAccessSchema = zod_1.z.enum(["organization", "project"]);
exports.createProjectOrgSchema = zod_1.z.discriminatedUnion("kind", [
    zod_1.z.object({ kind: zod_1.z.literal("existing"), tenantId: zod_1.z.string().uuid() }),
    zod_1.z.object({
        kind: zod_1.z.literal("new"),
        name: zod_1.z.string().trim().min(1, "Organization name is required").max(255),
        mainContact: zod_1.z.object({
            email: zod_1.z.string().trim().email(),
            name: zod_1.z.string().trim().min(1).max(255).optional(),
        }),
    }),
]);
exports.createProjectSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, "Project name is required"),
    projectType: zod_1.z.enum(["new_customer", "new_location", "mac_order"]).default("new_customer"),
    org: exports.createProjectOrgSchema,
    contacts: zod_1.z
        .array(zod_1.z.object({ email: zod_1.z.string().trim().email(), access: exports.contactAccessSchema }))
        .max(100)
        .default([]),
    // Initial project details
    seats: zod_1.z.number().int().min(1).optional(),
    didsCount: zod_1.z.number().int().min(0).optional(),
    e911Count: zod_1.z.number().int().min(0).optional(),
    webfaxCount: zod_1.z.number().int().min(0).optional(),
    callCenterAgents: zod_1.z.number().int().min(0).optional(),
    callCenterSupervisors: zod_1.z.number().int().min(0).optional(),
    smsUsers: zod_1.z.number().int().min(0).optional(),
    hasCallRecording: zod_1.z.boolean().optional(),
    hasTranscriptionSentiment: zod_1.z.boolean().optional(),
    callRecordingScope: zod_1.z.enum(["per_user", "all_domains"]).optional(),
    recordingUsers: zod_1.z.number().int().min(0).optional(),
    domainName: zod_1.z.string().optional(),
    reseller: zod_1.z.string().optional(),
    didsType: zod_1.z.enum(["porting", "new"]).optional(),
    hasTollFree: zod_1.z.boolean().optional(),
    tollFreeType: zod_1.z.enum(["porting", "new"]).optional(),
    portingDidNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    portingTfnNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    // SMS Compliance (TCR) - For new_customer projects with SMS enabled
    smsLegalCompanyName: zod_1.z.string().optional(),
    smsDbaName: zod_1.z.string().optional(),
    smsLegalForm: zod_1.z.enum(["public_profit", "private_profit", "non_profit", "government", "sole_proprietor"]).optional(),
    smsEin: zod_1.z.string().optional(),
    smsHqStreet: zod_1.z.string().optional(),
    smsHqCity: zod_1.z.string().optional(),
    smsHqState: zod_1.z.string().optional(),
    smsHqZip: zod_1.z.string().optional(),
    smsWebsite: zod_1.z.string().optional(),
    smsStockSymbol: zod_1.z.string().optional(),
    smsStockExchange: zod_1.z.string().optional(),
    smsVertical: zod_1.z.string().optional(),
    smsPrimaryContactFirstName: zod_1.z.string().optional(),
    smsPrimaryContactLastName: zod_1.z.string().optional(),
    smsPrimaryContactPhone: zod_1.z.string().optional(),
    // Wizard step visibility
    showCompanyInfo: zod_1.z.boolean().optional(),
    showExtensions: zod_1.z.boolean().optional(),
    showPhoneNumbers: zod_1.z.boolean().optional(),
    showMailboxes: zod_1.z.boolean().optional(),
    showAutoAttendants: zod_1.z.boolean().optional(),
    showTimeframes: zod_1.z.boolean().optional(),
    showHolidays: zod_1.z.boolean().optional(),
    showTodRouters: zod_1.z.boolean().optional(),
    showSmsCompliance: zod_1.z.boolean().optional(),
    // Intake Capture Expansion (Workstream B) step toggles
    showInstall: zod_1.z.boolean().optional(),
    showNetwork: zod_1.z.boolean().optional(),
    showSites: zod_1.z.boolean().optional(),
    showPorting: zod_1.z.boolean().optional(),
    showGreetings: zod_1.z.boolean().optional(),
});
// Update Company Info (CUSTOMER/COLLABORATOR can update during onboarding)
exports.updateCompanyInfoSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    seats: zod_1.z.number().int().min(1).optional(),
    didsCount: zod_1.z.number().int().min(0).optional(),
    e911Count: zod_1.z.number().int().min(0).optional(),
    webfaxCount: zod_1.z.number().int().min(0).optional(),
    callCenterAgents: zod_1.z.number().int().min(0).optional(),
    callCenterSupervisors: zod_1.z.number().int().min(0).optional(),
    smsUsers: zod_1.z.number().int().min(0).optional(),
    hasCallRecording: zod_1.z.boolean().optional(),
    hasTranscriptionSentiment: zod_1.z.boolean().optional(),
    callRecordingScope: zod_1.z.enum(["per_user", "all_domains"]).optional(),
    recordingUsers: zod_1.z.number().int().min(0).optional(),
    domainName: zod_1.z.string().optional(),
    reseller: zod_1.z.string().optional(),
    // Number porting (Workstream B) — reuses existing onboarding_project columns.
    hasTollFree: zod_1.z.boolean().optional(),
    tollFreeType: zod_1.z.enum(["porting", "new"]).optional(),
    portingDidNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    portingTfnNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    portDate: zod_1.z.string().max(20).optional(),
});
// Update SMS Compliance (CUSTOMER/COLLABORATOR can update during onboarding)
exports.updateSmsComplianceSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    smsLegalCompanyName: zod_1.z.string().optional(),
    smsDbaName: zod_1.z.string().optional(),
    smsLegalForm: zod_1.z.enum(["public_profit", "private_profit", "non_profit", "government", "sole_proprietor"]).optional(),
    smsEin: zod_1.z.string().optional(),
    smsHqStreet: zod_1.z.string().optional(),
    smsHqCity: zod_1.z.string().optional(),
    smsHqState: zod_1.z.string().optional(),
    smsHqZip: zod_1.z.string().optional(),
    smsWebsite: zod_1.z.string().optional(),
    smsStockSymbol: zod_1.z.string().optional(),
    smsStockExchange: zod_1.z.string().optional(),
    smsVertical: zod_1.z.string().optional(),
    smsPrimaryContactFirstName: zod_1.z.string().optional(),
    smsPrimaryContactLastName: zod_1.z.string().optional(),
    smsPrimaryContactPhone: zod_1.z.string().optional(),
});
// Update Project
exports.updateProjectSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(1).optional(),
    currentStep: zod_1.z.string().optional(),
});
// Submit for Review (CUSTOMER)
exports.submitForReviewSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
});
// Request Changes (REVIEWER)
exports.requestChangesSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    feedback: zod_1.z.string().min(1, "Feedback is required"),
});
// Approve Project (REVIEWER)
exports.approveProjectSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    totpCode: zod_1.z.string().length(6).optional(), // Required if user has TOTP enabled
});
// Delete Project
exports.deleteProjectSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
});
// ============================================================================
// PROJECT COLLABORATOR SCHEMAS
// ============================================================================
// Per-project capability roles (domain-org model)
exports.collaboratorRoleSchema = zod_1.z.enum(["viewer", "editor", "admin"]);
// Add Collaborator (existing user by id)
exports.addCollaboratorSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
    role: exports.collaboratorRoleSchema.default("viewer"),
});
// Add/Invite by Email (existing user → added directly; new email → invite-to-accept)
exports.inviteCollaboratorSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    email: zod_1.z.string().trim().toLowerCase().email(),
    role: exports.collaboratorRoleSchema.default("viewer"),
});
// Remove Collaborator
exports.removeCollaboratorSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
});
// Update Collaborator Role
exports.updateCollaboratorRoleSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
    role: exports.collaboratorRoleSchema,
});
// Resend a pending project invitation by email (rotates its token). There is no
// copy-link: an invite token only ever reaches the invitee's inbox, because accepting
// it signs them in (SP1 §4.4).
exports.resendInvitationSchema = zod_1.z.object({
    invitationId: zod_1.z.string().uuid(),
});
// List Collaborators
exports.listCollaboratorsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// PROVISIONING SCHEMAS
// ============================================================================
// Generate Provisioning Plan (PROVISIONER)
exports.generatePlanSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
});
// Apply Provisioning Plan (PROVISIONER with TOTP)
exports.applyPlanSchema = zod_1.z.object({
    planId: zod_1.z.string().uuid(),
    totpCode: zod_1.z.string().length(6), // Always required for apply
});
// Extension Number Validation (3-4 digit numbers only)
const extensionNumberSchema = zod_1.z.string()
    .min(3, "Extension number must be at least 3 digits")
    .max(4, "Extension number must be at most 4 digits")
    .regex(/^[0-9]+$/, "Extension number can only contain digits")
    .refine((val) => !/^[2-9]11$/.test(val), {
    message: "Extension number cannot be a reserved N11 service number (211, 311, 411, 511, 611, 711, 811, 911)"
});
// Extension Schema (Comprehensive - 25+ fields)
exports.extensionSchema = zod_1.z.object({
    // Basic Info
    firstName: zod_1.z.string().min(1, "First name is required"),
    lastName: zod_1.z.string().min(1, "Last name is required"),
    extensionNumber: extensionNumberSchema,
    // Login is the NetSapiens user name — always `<extensionNumber>@<domain>`.
    // We accept the client-computed value here (the UI renders it read-only)
    // and don't try to validate it against the project's domain at the edge;
    // the server re-derives it on write so there's no spoofing risk.
    login: zod_1.z.string().optional(),
    email: zod_1.z.string().email("Please enter a valid email."),
    // Voicemail Settings — PIN is 6 digits with no sequential runs and no
    // all-same-digit pins; see packages/shared/src/schemas/pin.ts.
    voicemailPin: zod_1.z
        .string()
        .refine((pin) => (0, pin_1.describePinError)(pin) === null, {
        message: "PIN must be 6 digits with no sequential or repeating runs.",
    })
        .optional(),
    vmailEnabled: zod_1.z.boolean().default(true),
    emailVmail: zod_1.z.boolean().default(false), // Email voicemail to user
    vmailTranscribe: zod_1.z.boolean().default(false), // Transcription enabled
    // Call Settings — stored as seconds but presented as rings (1 ring = 5s)
    // in the UI. Max 30 = 6 rings; min 5 = 1 ring.
    answerTimeout: zod_1.z.number().int().min(5).max(30).default(25),
    // Location/Organization
    department: zod_1.z.string().optional(),
    site: zod_1.z.string().optional(),
    timeZone: zod_1.z.string().default("US/Eastern"),
    areaCode: zod_1.z.string().length(3).optional(), // 3-digit area code
    // Caller ID
    callerIdNumber: zod_1.z.string().optional(),
    callerIdName: zod_1.z.string().max(15).optional(), // Max 15 chars for caller ID
    e911CallerId: zod_1.z.string().optional(), // E911 caller ID number
    // Permissions & Features
    dialPermission: zod_1.z.string().default("US and Canada"),
    audioDirectory: zod_1.z.boolean().default(true), // Listed in audio directory
    visualDirectory: zod_1.z.boolean().default(true), // Listed in visual directory
    recording: zod_1.z.boolean().default(false), // Call recording enabled
    // NetSapiens scope / user type. We allowlist the four we actually support.
    scope: zod_1.z
        .enum(["Basic User", "Call Center Agent", "Call Center Supervisor", "Office Manager"])
        .default("Basic User"),
    // Phone Hardware
    addPhoneExtension: zod_1.z.boolean().default(false), // Add physical phone
    hardware: zod_1.z.string().optional(), // Phone model (e.g., "Polycom VVX 450")
    mac: zod_1.z.string().regex(/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/).optional(), // MAC address
});
exports.createExtensionSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    extension: exports.extensionSchema,
});
exports.updateExtensionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    extension: exports.extensionSchema.partial(),
});
exports.deleteExtensionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listExtensionsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// Phone Number Schema (Enhanced with treatment, destination, SMS)
exports.phoneNumberSchema = zod_1.z.object({
    e164: zod_1.z.string().regex(/^\+?[1-9]\d{1,14}$/, "Invalid E.164 phone number"),
    label: zod_1.z.string().optional(),
    // Call Treatment
    treatment: zod_1.z.enum(["transfer", "voicemail", "hangup", "announcement"]).default("transfer"),
    // Call Destination
    destinationType: zod_1.z.enum(["extension", "queue", "aa", "ringgroup", "todrouter", "conference", "external", "mailbox"]).optional(),
    destinationId: zod_1.z.string().uuid().optional(),
    destinationValue: zod_1.z.string().optional(), // For external numbers
    // Legacy fields (backward compatibility)
    assignedToType: zod_1.z.enum(["extension", "queue", "aa", "external"]).optional(),
    assignedToId: zod_1.z.string().uuid().optional(),
    // SMS Settings
    smsEnabled: zod_1.z.boolean().default(false),
    smsDestinationType: zod_1.z.enum(["extension", "queue", "email", "webhook"]).optional(),
    smsDestinationId: zod_1.z.string().uuid().optional(),
    smsDestinationValue: zod_1.z.string().optional(), // Email address, webhook URL
    // Notes & Port Status
    notes: zod_1.z.string().optional(),
    portStatus: zod_1.z.enum(["pending", "active", "ported", "cancelled"]).default("active"),
    portDate: zod_1.z.date().or(zod_1.z.string().transform((str) => new Date(str))).optional(), // Date or ISO string
});
exports.createPhoneNumberSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    phoneNumber: exports.phoneNumberSchema,
});
exports.updatePhoneNumberSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    phoneNumber: exports.phoneNumberSchema.partial(),
});
exports.deletePhoneNumberSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listPhoneNumbersSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// MAILBOX SCHEMAS
// ============================================================================
exports.mailboxSchema = zod_1.z.object({
    // Basic Info
    extensionNumber: extensionNumberSchema,
    firstName: zod_1.z.string().min(1, "First name is required"),
    lastName: zod_1.z.string().min(1, "Last name is required"),
    login: zod_1.z.string().optional(),
    emailAddress: zod_1.z.string().email().optional(),
    // Voicemail Settings
    voicemailPin: zod_1.z.string().min(4).max(6).optional(),
    emailVmail: zod_1.z.boolean().default(false),
    vmailTranscribe: zod_1.z.boolean().default(false),
    // Organization
    department: zod_1.z.string().optional(),
    site: zod_1.z.string().optional(),
    // Shared Line
    sharedLine: zod_1.z.boolean().default(false),
});
exports.createMailboxSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    mailbox: exports.mailboxSchema,
});
exports.updateMailboxSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    mailbox: exports.mailboxSchema.partial(),
});
exports.deleteMailboxSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listMailboxesSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// AUTO ATTENDANT SCHEMAS
// ============================================================================
exports.autoAttendantOptionSchema = zod_1.z.object({
    key: zod_1.z.string().min(1).max(10), // "1", "2", "0", "*", "#"
    treatment: zod_1.z.enum(["transfer", "voicemail", "hangup", "submenu", "playback"]).default("transfer"),
    destinationType: zod_1.z.enum(["extension", "queue", "aa", "ringgroup", "external", "mailbox"]).optional(),
    destinationId: zod_1.z.string().uuid().optional(),
    destinationValue: zod_1.z.string().optional(),
    playbackText: zod_1.z.string().optional(), // TTS text
    playbackAudioUrl: zod_1.z.string().url().optional(),
    returnToMenu: zod_1.z.boolean().default(true),
    label: zod_1.z.string().optional(), // Human-readable (e.g., "Sales")
});
exports.autoAttendantSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    extensionNumber: extensionNumberSchema,
    // Greeting
    greetingType: zod_1.z.enum(["default", "custom", "tts"]).default("default"),
    greetingText: zod_1.z.string().optional(),
    // Absolute URL or app-relative download path (e.g. /api/files/<id>) for
    // custom uploaded greeting audio (Workstream B).
    greetingAudioUrl: zod_1.z.string().max(500).optional(),
    // Behavior
    timeout: zod_1.z.number().int().min(1).max(30).default(5),
    maxRetries: zod_1.z.number().int().min(1).max(10).default(3),
    allowDialByExtension: zod_1.z.boolean().default(true),
    // Timeout Treatment
    timeoutTreatment: zod_1.z.enum(["repeat", "transfer", "voicemail", "hangup"]).default("repeat"),
    timeoutDestinationType: zod_1.z.enum(["extension", "queue", "aa", "external"]).optional(),
    timeoutDestinationId: zod_1.z.string().uuid().optional(),
    timeoutDestinationValue: zod_1.z.string().optional(),
    // Invalid Treatment
    invalidTreatment: zod_1.z.enum(["repeat", "transfer", "voicemail", "hangup"]).default("repeat"),
    invalidDestinationType: zod_1.z.enum(["extension", "queue", "aa", "external"]).optional(),
    invalidDestinationId: zod_1.z.string().uuid().optional(),
    invalidDestinationValue: zod_1.z.string().optional(),
});
exports.createAutoAttendantSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    autoAttendant: exports.autoAttendantSchema,
});
exports.updateAutoAttendantSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    autoAttendant: exports.autoAttendantSchema.partial(),
});
exports.deleteAutoAttendantSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listAutoAttendantsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// AA Options CRUD
exports.createAAOptionSchema = zod_1.z.object({
    autoAttendantId: zod_1.z.string().uuid(),
    option: exports.autoAttendantOptionSchema,
});
exports.updateAAOptionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    option: exports.autoAttendantOptionSchema.partial(),
});
exports.deleteAAOptionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listAAOptionsSchema = zod_1.z.object({
    autoAttendantId: zod_1.z.string().uuid(),
});
// ============================================================================
// RING GROUP SCHEMAS
// ============================================================================
exports.ringGroupSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    extensionNumber: extensionNumberSchema,
    // Ring Strategy
    ringStrategy: zod_1.z.enum(["ringall", "linear", "hunt", "rr", "rrmemory"]).default("ringall"),
    answerTime: zod_1.z.number().int().min(5).max(120).default(20),
    // Caller ID
    callerIdName: zod_1.z.string().max(15).optional(),
    callerIdNumber: zod_1.z.string().optional(),
    // Voicemail
    vmailEnabled: zod_1.z.boolean().default(false),
    vmailExtension: zod_1.z.string().optional(),
    // Unanswered Treatment
    unansweredTreatment: zod_1.z.enum(["voicemail", "transfer", "hangup"]).default("voicemail"),
    unansweredDestinationType: zod_1.z.enum(["extension", "queue", "aa", "external", "mailbox"]).optional(),
    unansweredDestinationId: zod_1.z.string().uuid().optional(),
    unansweredDestinationValue: zod_1.z.string().optional(),
    // Offline Treatment
    offlineTreatment: zod_1.z.enum(["voicemail", "transfer", "hangup"]).default("voicemail"),
    offlineDestinationType: zod_1.z.enum(["extension", "queue", "aa", "external", "mailbox"]).optional(),
    offlineDestinationId: zod_1.z.string().uuid().optional(),
    offlineDestinationValue: zod_1.z.string().optional(),
    // Additional Settings
    skipBusyExtensions: zod_1.z.boolean().default(true),
    announceCall: zod_1.z.boolean().default(false),
    recordCalls: zod_1.z.boolean().default(false),
});
exports.createRingGroupSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    ringGroup: exports.ringGroupSchema,
});
exports.updateRingGroupSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    ringGroup: exports.ringGroupSchema.partial(),
});
exports.deleteRingGroupSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listRingGroupsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// Ring Group Member Management
exports.setRingGroupMembersSchema = zod_1.z.object({
    ringGroupId: zod_1.z.string().uuid(),
    memberIds: zod_1.z.array(zod_1.z.string().uuid()), // Extension IDs
});
// ============================================================================
// QUEUE SCHEMAS
// ============================================================================
exports.queueSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    extensionNumber: extensionNumberSchema,
    queueType: zod_1.z.enum(["standard", "priority", "skill-based"]).default("standard"),
    // Organization
    department: zod_1.z.string().optional(),
    site: zod_1.z.string().optional(),
    // Ring Strategy
    ringType: zod_1.z.enum(["ringall", "linear", "rr", "rrmemory"]).default("ringall"),
    // Queue Behavior
    requireAgents: zod_1.z.boolean().default(true),
    maxExpectedWait: zod_1.z.number().int().min(0).default(300),
    maxQueueLength: zod_1.z.number().int().min(0).default(0), // 0 = unlimited
    ringTime: zod_1.z.number().int().min(5).max(120).default(20),
    agentTimeout: zod_1.z.number().int().min(0).max(60).default(15),
    // Callback & Voicemail
    callbackEnabled: zod_1.z.boolean().default(false),
    voicemailEnabled: zod_1.z.boolean().default(true),
    voicemailExtension: zod_1.z.string().optional(),
    // If Unavailable Treatment
    ifUnavailableTreatment: zod_1.z.enum(["voicemail", "transfer", "hangup", "announcement"]).default("voicemail"),
    ifUnavailableDestinationType: zod_1.z.enum(["extension", "queue", "aa", "external", "mailbox"]).optional(),
    ifUnavailableDestinationId: zod_1.z.string().uuid().optional(),
    ifUnavailableDestinationValue: zod_1.z.string().optional(),
    // If Unanswered Treatment
    ifUnansweredTreatment: zod_1.z.enum(["voicemail", "transfer", "hangup"]).default("voicemail"),
    ifUnansweredDestinationType: zod_1.z.enum(["extension", "queue", "aa", "external", "mailbox"]).optional(),
    ifUnansweredDestinationId: zod_1.z.string().uuid().optional(),
    ifUnansweredDestinationValue: zod_1.z.string().optional(),
    // Agent Groups
    initialAgentGroup: zod_1.z.string().optional(),
    agentGroupToAddAfterTimeout: zod_1.z.string().optional(),
    // Additional Settings
    announcePosition: zod_1.z.boolean().default(true),
    announceHoldTime: zod_1.z.boolean().default(false),
    musicOnHold: zod_1.z.string().default("default"),
    recordCalls: zod_1.z.boolean().default(false),
});
exports.createQueueSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    queue: exports.queueSchema,
});
exports.updateQueueSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    queue: exports.queueSchema.partial(),
});
exports.deleteQueueSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listQueuesSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// Queue Member Management
exports.setQueueMembersSchema = zod_1.z.object({
    queueId: zod_1.z.string().uuid(),
    memberIds: zod_1.z.array(zod_1.z.string().uuid()), // Extension IDs
});
// ============================================================================
// CONFERENCE BRIDGE SCHEMAS
// ============================================================================
exports.conferenceBridgeSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    extensionNumber: extensionNumberSchema,
    // Security
    leaderPin: zod_1.z.string().min(4).max(20).optional(),
    participantPin: zod_1.z.string().min(4).max(20).optional(),
    // Conference Settings
    maxParticipants: zod_1.z.number().int().min(0).default(50), // 0 = unlimited
    minToStart: zod_1.z.number().int().min(1).default(1),
    requireLeader: zod_1.z.boolean().default(false),
    // Announcements
    announceParticipants: zod_1.z.boolean().default(true),
    promptParticipantsForName: zod_1.z.boolean().default(false),
    // Recording
    recordConference: zod_1.z.boolean().default(false),
    recordingFormat: zod_1.z.enum(["wav", "mp3"]).default("wav"),
    // Music on Hold
    musicOnHold: zod_1.z.boolean().default(false),
    mohClass: zod_1.z.string().default("default"),
    // Advanced Settings
    quietMode: zod_1.z.boolean().default(false),
    waitForLeader: zod_1.z.boolean().default(false),
    endWhenLeaderLeaves: zod_1.z.boolean().default(false),
    allowMute: zod_1.z.boolean().default(true),
    allowKick: zod_1.z.boolean().default(true),
});
exports.createConferenceBridgeSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    conferenceBridge: exports.conferenceBridgeSchema,
});
exports.updateConferenceBridgeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    conferenceBridge: exports.conferenceBridgeSchema.partial(),
});
exports.deleteConferenceBridgeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listConferenceBridgesSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// SITE SCHEMAS
// ============================================================================
exports.siteSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    code: zod_1.z.string().max(50).optional(),
    description: zod_1.z.string().optional(),
    // Location
    addressLine1: zod_1.z.string().optional(),
    addressLine2: zod_1.z.string().optional(),
    city: zod_1.z.string().optional(),
    state: zod_1.z.string().optional(),
    postalCode: zod_1.z.string().optional(),
    country: zod_1.z.string().default("USA"),
    // Telephony Settings
    timeZone: zod_1.z.string().default("US/Eastern"),
    areaCode: zod_1.z.string().length(3).optional(),
    // Caller ID
    callerIdName: zod_1.z.string().max(15).optional(),
    callerIdNumber: zod_1.z.string().optional(),
    // E911
    e911CallerId: zod_1.z.string().optional(),
    e911Location: zod_1.z.string().optional(),
    // Permissions
    dialPermission: zod_1.z.string().default("US and Canada"),
    // Network
    sipServer: zod_1.z.string().optional(),
    codec: zod_1.z.string().default("G.722"),
    // Status
    active: zod_1.z.boolean().default(true),
});
exports.createSiteSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    site: exports.siteSchema,
});
exports.updateSiteSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    site: exports.siteSchema.partial(),
});
exports.deleteSiteSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listSitesSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// TIMEFRAME SCHEMAS
// ============================================================================
exports.timeframeRuleSchema = zod_1.z.object({
    ruleType: zod_1.z.enum(["dow", "date", "exclusion"]).default("dow"),
    dow: zod_1.z.number().int().min(0).max(6).optional(), // 0=Sunday, 6=Saturday
    start: zod_1.z.string().regex(/^\d{2}:\d{2}$/, "Start time must be in HH:MM format"),
    end: zod_1.z.string().regex(/^\d{2}:\d{2}$/, "End time must be in HH:MM format"),
    specificDate: zod_1.z.date().or(zod_1.z.string().transform((str) => new Date(str))).optional(),
});
exports.timeframeSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    kind: zod_1.z.enum(["business-hours", "holiday", "lunch", "after-hours", "one-time"]).default("business-hours"),
    priority: zod_1.z.number().int().min(0).max(100).default(10),
    // Date Range (for one-time or limited timeframes)
    startDate: zod_1.z.date().or(zod_1.z.string().transform((str) => new Date(str))).optional(),
    endDate: zod_1.z.date().or(zod_1.z.string().transform((str) => new Date(str))).optional(),
    // Call Treatment
    treatment: zod_1.z.enum(["transfer", "voicemail", "hangup", "announcement"]).default("transfer"),
    destinationType: zod_1.z.enum(["extension", "queue", "aa", "ringgroup", "external", "mailbox"]).optional(),
    destinationId: zod_1.z.string().uuid().optional(),
    destinationValue: zod_1.z.string().optional(),
    // Announcement
    announcementType: zod_1.z.enum(["default", "custom", "tts"]).optional(),
    announcementText: zod_1.z.string().optional(),
    announcementAudioUrl: zod_1.z.string().url().optional(),
    // Rules (days/times when this timeframe applies)
    rules: zod_1.z.array(exports.timeframeRuleSchema).optional(),
});
exports.createTimeframeSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    timeframe: exports.timeframeSchema,
});
exports.updateTimeframeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    timeframe: exports.timeframeSchema.partial(),
});
exports.deleteTimeframeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listTimeframesSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// HOLIDAY SCHEMAS
// ============================================================================
exports.holidaySchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    date: zod_1.z.date().or(zod_1.z.string().transform((str) => new Date(str))),
    recurring: zod_1.z.boolean().optional().default(false),
    // Routing (required by database)
    destinationType: zod_1.z.enum(["extension", "queue", "aa", "ringgroup", "external", "mailbox", "voicemail"]).default("voicemail"),
    destinationId: zod_1.z.string().uuid().optional(),
});
exports.createHolidaySchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    holiday: exports.holidaySchema,
});
exports.updateHolidaySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    holiday: exports.holidaySchema.partial(),
});
exports.deleteHolidaySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listHolidaysSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// TIME-OF-DAY ROUTER SCHEMAS
// ============================================================================
exports.todRouterBindingSchema = zod_1.z.object({
    timeframeId: zod_1.z.string().uuid(),
    destinationType: zod_1.z.enum(["extension", "queue", "aa", "ringgroup", "external", "mailbox"]),
    destinationId: zod_1.z.string().uuid().optional(),
    destinationValue: zod_1.z.string().optional(), // For external numbers
});
exports.todRouterSchema = zod_1.z.object({
    // Basic Info
    name: zod_1.z.string().min(1, "Name is required"),
    extensionNumber: extensionNumberSchema,
    description: zod_1.z.string().optional(),
    // Default Destination (when no timeframes match)
    defaultDestinationType: zod_1.z.enum(["extension", "queue", "aa", "ringgroup", "external", "mailbox", "voicemail", "hangup"]).default("voicemail"),
    defaultDestinationId: zod_1.z.string().uuid().optional(),
    defaultDestinationValue: zod_1.z.string().optional(),
    // Timezone
    timeZone: zod_1.z.string().default("US/Eastern"),
    // Bindings (timeframe → destination mappings)
    bindings: zod_1.z.array(exports.todRouterBindingSchema).optional(),
});
exports.createTodRouterSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    todRouter: exports.todRouterSchema,
});
exports.updateTodRouterSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    todRouter: exports.todRouterSchema.partial(),
});
exports.deleteTodRouterSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listTodRoutersSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// IMPORT/EXPORT SCHEMAS
// ============================================================================
exports.importExtensionsPreviewSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    data: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.any())), // Raw CSV/XLSX data
});
exports.importExtensionsCommitSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    extensions: zod_1.z.array(exports.extensionSchema),
});
exports.exportExtensionsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    format: zod_1.z.enum(["csv", "xlsx"]).default("xlsx"),
});
exports.importPhoneNumbersPreviewSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    data: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.any())),
});
exports.importPhoneNumbersCommitSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    phoneNumbers: zod_1.z.array(exports.phoneNumberSchema),
});
exports.exportPhoneNumbersSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    format: zod_1.z.enum(["csv", "xlsx"]).default("xlsx"),
});
// ============================================================================
// Comments Schemas
// ============================================================================
exports.commentSchema = zod_1.z.object({
    body: zod_1.z.string().min(1, "Comment cannot be empty"),
    path: zod_1.z.string().optional(),
});
exports.createCommentSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    comment: exports.commentSchema,
});
exports.updateCommentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    body: zod_1.z.string().min(1, "Comment cannot be empty"),
});
exports.deleteCommentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listCommentsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// ============================================================================
// Tasks Schemas
// ============================================================================
exports.taskSchema = zod_1.z.object({
    title: zod_1.z.string().min(1, "Title is required"),
    assigneeId: zod_1.z.string().uuid().optional(),
    status: zod_1.z.enum(["todo", "in_progress", "done"]).default("todo"),
    targetPath: zod_1.z.string().optional(),
    wizardStep: zod_1.z.string().optional(), // Link to specific wizard step (e.g., "company-info", "dns-setup")
});
exports.createTaskSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    task: exports.taskSchema,
});
exports.updateTaskSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    task: exports.taskSchema.partial(),
});
exports.deleteTaskSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.listTasksSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
}).merge(common_1.paginationSchema);
// Project Infrastructure (Install & Migration + Network wizard steps)
exports.infrastructureSchema = zod_1.z
    .object({
    projectId: zod_1.z.string().uuid(),
    goLiveDate: zod_1.z.string().date().optional(),
    installResponsibility: zod_1.z.enum(["self", "telecloud", "third_party"]).optional(),
    thirdPartyContact: zod_1.z.string().max(255).optional(),
    currentProvider: zod_1.z.string().max(255).optional(),
    currentLineCount: zod_1.z.number().int().nonnegative().optional(),
    migrationNotes: zod_1.z.string().optional(),
    internetProvider: zod_1.z.string().max(255).optional(),
    internetType: zod_1.z.string().max(100).optional(),
    bandwidth: zod_1.z.string().max(100).optional(),
    hasStaticIp: zod_1.z.boolean().optional(),
    staticIpDetails: zod_1.z.string().max(255).optional(),
    itContactName: zod_1.z.string().max(255).optional(),
    itContactEmail: zod_1.z.string().email().max(255).optional().or(zod_1.z.literal("")),
    itContactPhone: zod_1.z.string().max(50).optional(),
    isConvergedNetwork: zod_1.z.boolean().optional(),
    firewallMakeModel: zod_1.z.string().max(255).optional(),
    routerMakeModel: zod_1.z.string().max(255).optional(),
    switchMakeModel: zod_1.z.string().max(255).optional(),
    switchCount: zod_1.z.number().int().nonnegative().optional(),
    cablingNotes: zod_1.z.string().optional(),
})
    .refine((v) => v.installResponsibility !== "third_party" || !!v.thirdPartyContact, {
    message: "Third-party install requires a contact",
    path: ["thirdPartyContact"],
})
    .refine((v) => !v.isConvergedNetwork || !!(v.firewallMakeModel || v.routerMakeModel || v.switchMakeModel), {
    message: "Converged network requires at least one device (firewall/router/switch)",
    path: ["firewallMakeModel"],
});
exports.getInfrastructureSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
});
